/**
 * Messages génériques de l'application
 */

module.exports = {

    cancel: 'Cancel',
    back: 'Back',
    next: 'Next',
    close: 'Close',

    delete: 'Delete',
    save: 'Save',
    finish: 'Finish',
    add: 'Add',
    edit: 'Edit',
    apply: 'Apply',
    reset: 'Reset',
    loadMore: 'Load more',
    validate: 'Validate',
    confirm: 'Confirm',
    connect: 'Connect',
    order: 'Order',
    generate: 'Generate',
    download: 'Download',
    import: 'Import',
    export: 'Export lines displayed',
    send: 'Send',

    yes: 'Yes',
    no: 'No',

    showMore: 'Show more',
    showLess: 'Show less',

    percent: '{ percent } %',

    time: {
        short: '{ hours }H{ minutes }',
        full: '{ hours }H{ minutes }\'{ seconds }\'\'',

        days: '0 days | 1 day | { days } days',
        hours: '00 hours | 01 hour | { hours } hours',
        minutes: '00 minutes | 01 minute | { minutes } minutes',
        seconds: '00 seconds | 01 second | { seconds } seconds',
    },

    size: {
        disk: '{ size } MB'
    },

    step: 'Step { current }/{ total }',

    icon: {
        alt: 'Icon { name }.'
    },

    password: {
        altLabel: {
            show: 'Show password',
            hide: 'Hide password'
        }
    },

    list: {
        empty: 'No element was found'
    },

    contract: {
        types: {
            fixedTermContract: 'Fixed Term Contract',
            permanentContract: 'Permanent Contract',
            traineeship: 'Internship',
            free: 'Freelance',
            society: 'Society'
        }
    },

    lang: {
        byCode: {
            fr: 'French',
            en: 'English',
            es: 'Spanish',
            de: 'German'
        }
    },

    translation: {
        button: {
            display: {
                show: 'Show translations',
                hidden: 'Hide translations'
            }
        }
    },

    week: {
        dayNames: {
            monday: 'Monday',
            tuesday: 'Tuesday',
            wednesday: 'Wednesday',
            thursday: 'Thursday',
            friday: 'Wednesday',
            saturday: 'Saturday',
            sunday: 'Sunday'
        }
    },

    month: {
        current: '{ month } { year }'
    },

    frequency: {
        monthly: 'monthly',
        yearly: 'yearly'
    },

    requestHolidays: {
        type: {
            paidHolidays: 'Paid holidays',
            unpaidLeave: 'Unpaid holidays',
            repose: 'Rest'
        },
        status: {
            waiting: 'On hold',
            accepted: 'Accepted',
            declined: 'Declined'
        },
    },

    editorialLine: {
        institutional: 'Institutional',
        humor: 'Humor',
        original: 'Original',
        inspiring: 'Inspiring',
        custom: 'Customized tone',
        technicalExpert: 'Technical Expert',
        pedagogue: 'Pedagogue',
        journalistic: 'Journalistic',
        promotional: 'Promotional',
        emotional: 'Emotional'
    },

    activityType: {
        unknown: 'Unknown',
        bToC: 'BtoC',
        bToB: 'BtoB',
        bToBToC: 'BtoBtoC',
        cToC: 'CtoC'
    },

    formality: {
        familiarity: 'Informal adress',
        formality: 'Formal adress'
    },

    emoticonType: {
        without: 'Without emoji',
        institutional: 'Moderate',
        emotional: 'Emotional'
    },

    marketingObjectives: {
        visibility: 'Visibility',
        traffic: 'Traffic',
        engagement: 'Engagement'
    },


    // Sélection d'un émoticône
    selectedEmoticon: {
        button: {
            category: {
                label: 'Select an emoticon'
            }
        }
    },

    // Template des chartes graphiques
    graphicalLineTemplate: {
        status: {
            draft: 'Draft',
            enabled: 'Enabled',
            disabled: 'Disabled'
        },
        format: {
            '1:1': '1:1',
            '16:9': '16:9',
            '9:16': '9:16'
        }
    },

    // Plugin Pixlr
    pixlrPlugin: {
        closeButton: {
            altLabel: 'Сlose editor'
        }
    },

    // Plugin Konva pour l'édition d'image
    konvaPlugin: {
        addImageButton: {
            label: 'Add an image'
        },
        addShapeButton: {
            label: 'Add a form'
        },
        addTextButton: {
            label: 'Add a text zone'
        },
        removeButton: {
            altLabel: 'Remove this element.'
        },
        moveUpButton: {
            altLabel: 'Move up this element.'
        },
        moveDownButton: {
            altLabel: 'Move down this element'
        },
        expandImageButton: {
            altLabel: 'Expand image size.'
        },
        changeImageButton: {
            altLabel: 'Use another image'
        },
        changeTextContentTypeButton: {
            altLabel: 'Change the text type.'
        },

        changeImageContentTypeButton: {
            altLabel: 'Change image type.'
        },

        imageContentType: {
            type: {
                label: 'Image type',
            },
            types: {
                logo: 'Logo',
                publicationImage: 'Post image'
            },
            isLogo: 'Logo'
        },

        fontSize: {
            label: 'Taille de police'
        },

        textMaxCharacters: {
            label: 'Maximum number of characters'
        },

        textContentTypeSelect: {
            label: 'Text type',
            default: 'Choose the type',
            options: {
                heading1: 'Heading 1',
                heading2: 'Heading 2',
                description: 'Description'
            }
        },
        opacityInput: {
            label: 'Percentage of opacity',
        },

        displayTextEditorButton: {
            altLabel: 'Edit text.'
        },

        customColorButton: {
            label: 'Custom color'
        },

        editOpacityButton: {
            altLabel: 'Modify the opacity of this element.'
        },

        editShapeButton: {
            altLabel: 'Modify the parameters of this form.'
        },

        editShape: {
            fields: {
                type: 'Form type',
                backgroundColor: 'Background color',
                withBorder: 'Use the border',
                borderSize: 'Border size',
                borderColor: 'Border color',
                radius: 'Rounding corners',
                masked: 'Transparent element'
            },
            color: {
                none: 'None',
                custom: 'Customized'
            },
            types: {
                default: 'Choose the form type',
                rectangle: 'Rectangle',
                triangle: 'Triangle',
                circle: 'Circle'
            }
        },

        editStageBackgroundButton: {
            altLabel: 'Manage the editor\'s background.',
        },

        addFontButton: {
            altLabel: 'Add a font.'
        },

        editBackground: {
            fields: {
                type: 'Background type',
                color: 'Background color',
                colorIndex: 'Couleur du client',
                gradient: {
                    color: 'Color { position }',
                    percent: 'Percentage start'
                }
            },
            addGradientColorButton: {
                label: 'Add a color'
            },
            types: {
                none: 'None',
                color: 'Unique color',
                gradient: 'Gradient'
            }
        },

        colorIndexes: {
            label: 'Customer color',
            none: 'None',
            primary: 'Primary',
            secondary: 'Secondary',
            tertiary: 'Tertiary'
        },

        addFontModal: {
            title: 'Add a font'
        }
    },
    aiModels: {
        claude: 'Claude',
        // 'gpt-4o': 'GPT-4o',
        'gpt-5': 'GPT-5',
        'gpt-5-4-mini': 'GPT-5.4'
    },

    contactUs: {
        button: {
            altLabel: 'Send us a message.'
        },
        modal: {
            title: 'Contact us'
        },
        form: {
            error: 'An error occurred while sending your message.',
            success: 'Your message has been sent successfully.',
            fields: {
                email: 'Email address to contact you',
                message: 'How can we help you'
            }
        }
    },

    pronouns: {
        firstSingular: 'I',
        firstPlural: 'We',
        thirdSingular: 'One'
    },
    languageRegisters: {
        formal: 'Formal language',
        familiar: 'Familiar language',
        proximity: 'Proximate language'
    },
    tones: {
        expert: 'Expert',
        accessible: 'Accessible',
        offbeat: 'Offbeat',
        committed: 'Committed'
    },

    writingStyle: {
        category: {
            informational: 'Informational',
            advice: 'Advice',
            promotional: 'Promotional'
        }
    }

};
